var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeasurementPointCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ll1zhwkh0a",
    width: "318.2%",
    height: "318.2%",
    x: "-109.1%",
    y: "-109.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 3,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 13
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "igc6ddcufc"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.117647 0 0 0 0 0.141176 0 0 0 0 0.278431 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "en2fka6kfb",
    cx: 22,
    cy: 22,
    r: 22
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1369 -193) translate(1190 48) translate(179 145)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ll1zhwkh0a)",
    xlinkHref: "#en2fka6kfb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#en2fka6kfb"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0z",
    transform: "translate(-1369 -193) translate(1190 48) translate(179 145) translate(10 11)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#igc6ddcufc)",
    transform: "translate(-1369 -193) translate(1190 48) translate(179 145) translate(10 11)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 5)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.618
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13,
    cy: 3.712,
    rx: 1.647,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.353 3.712L10.847 8.736 11.434 9.421 14.729 9.421 15.365 8.71 14.647 3.712M10.86 8.608L15.254 8.631M14.716 4.191l3.477-.479s.838-.212.852-.802M14.864 5.221c.13-.018 3.439-.444 3.439-.444s.81-.055.838.81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.825 4.835c.328 1.592 1.7 2.789 3.341 2.789 1.89 0 3.42-1.586 3.42-3.536s-1.53-3.53-3.42-3.53c-1.786 0-3.256 1.416-3.402 3.214M11.173 4.513L7.85 4.987M11.045 5.789L7.825 6.05M7.825 6.05c-.285 1.732-1.767 3.044-3.56 3.044-1.992 0-3.614-1.64-3.614-3.663 0-2.03 1.622-3.67 3.614-3.67 1.853 0 3.372 1.41 3.585 3.226"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.66,
    cy: 5.428,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.742 9.421L12.371 10.416 13.66 10.416 14.397 9.421M12.529 10.416H13.529V14.052H12.529zM23.027 2.74s.965 1.588-.176 2.953M22.17 6.286s-.327.16-.621.172"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4.25,
    cy: 5.469,
    r: 2.694,
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.618
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    fillRule: "nonzero",
    d: "M4.25 6.224c-.855 0-1.571-.563-1.819-1.337-.06.185-.1.378-.1.582 0 1.06.86 1.919 1.92 1.919 1.059 0 1.918-.86 1.918-1.919 0-.204-.04-.397-.1-.582-.247.774-.963 1.337-1.819 1.337z"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementPointCircle);
export default __webpack_public_path__ + "static/media/measurement-point-circle.7e59ff66.svg";
export { ForwardRef as ReactComponent };